import styled from "styled-components";

import arrowDown from "../../assets/images/arrow-down.svg";

export const SelectboxMenu = styled.div`
  background: url(${arrowDown}) center right 10px no-repeat;
  background-size: 13px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.color21};
  color: ${({ theme }) => theme.colors.color21};
  cursor: pointer;
  font-size: 22px;
  font-weight: 700;
  height: 39px;
  margin-top: 33px;
  width: 120px;
`;

export const Label = styled.div`
  margin: 5px;
`;

export const SelectboxItems = styled.ul`
  background-color: ${({ theme }) => theme.colors.color18};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.color21};
  margin: 25px 0 0 0;
  position: relative;
  width: 100%;
  z-index: 50;

  &:before {
    ${({ theme }) => theme.colors.color21} transparent;
    border-color: transparent transparent;
    border-style: solid;
    border-width: 0 12.5px 12px 12.5px;
    content: "";
    display: inline-block;
    height: 0;
    position: absolute;
    right: 43%;
    top: -12px;
    width: 0;
  }
`;

export const SelectboxItem = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.color22};
  height: 39px;
  padding: 5px;
  width: 100%;

  &:hover {
    background-color: ${({ theme }) => theme.colors.color15};
  }
`;
export const SelectboxLabel = styled.span`
`;
